<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout justify-center>
        <v-flex xs12 lg9>
          <v-card class="information">
            <v-card-title class="headline">
              <v-flex xs12>
                {{ business.title }}
              </v-flex>
              <v-flex xs12 pt-2 v-if="$isSuperuser()">
                <PublishedChip :value="business" />
              </v-flex>
            </v-card-title>
            <v-card-text>
              <table>
                <tr>
                  <th class="text-xs-left pr-4">Geschäftsnummer</th>
                  <td>{{ business.number }}</td>
                </tr>
                <tr v-if="business.commission">
                  <th class="text-xs-left pr-4">Vorberatende Kommission</th>
                  <td>{{ business.commission.title }}</td>
                </tr>
                <tr>
                  <th class="text-xs-left pr-4">Status</th>
                  <td>{{ business.status }}</td>
                </tr>
                <tr>
                  <th class="text-xs-left pr-4">Eröffnungsdatum</th>
                  <td>{{ business.opening_date | toLocaleDateString }}</td>
                </tr>
                <tr>
                  <th class="text-xs-left pr-4">Abschlussdatum</th>
                  <td>{{ business.closing_date | toLocaleDateTimeString }}</td>
                </tr>
                <tr v-if="$isSuperuser()">
                  <th class="text-xs-left pr-4">Veröffentlicht per</th>
                  <td>
                    {{ business.publishing_datetime | toLocaleDateTimeString }}
                  </td>
                </tr>
                <tr v-if="$isSuperuser()">
                  <th class="text-xs-left pr-4">Letzte Änderung</th>
                  <td>{{ business.modified | toLocaleDateTimeString }}</td>
                </tr>
              </table>
            </v-card-text>
            <v-card-actions>
              <template v-if="$isSuperuser()">
                <v-btn
                  @click="$showNotificationDialog"
                  depressed
                >Benachrichtigen</v-btn>
                <v-btn
                  :to="business.editURL"
                  depressed
                >Bearbeiten</v-btn>
                <v-btn
                  @click="destroy"
                  color="red"
                  depressed
                  dark
                >Löschen</v-btn>
              </template>
              <v-spacer />
              <v-btn
                depressed
                @click="downloadZip"
                :disabled="!hasFiles"
                :loading="zipLoading">
                <v-icon
                  class="ml-0"
                  left
                  right>
                  cloud_download
                </v-icon>
                Alle Dokumente
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-layout justify-center>
        <v-flex xs12 lg9>
          <v-card class="journal-entries">
            <v-card-text class="pa-0">
              <template v-for="(journalEntry, index) in journalEntries">
                <JournalEntry
                  :value="journalEntry"
                  :key="journalEntry.listKey"
                  @edit="editJournal"
                  @delete="confirmedDestroy"
                />
                <v-divider
                  v-if="index + 1 < journalEntries.length"
                  :key="index"
                />
              </template>
            </v-card-text>
            <v-card-actions v-if="$isSuperuser()">
              <v-btn
                @click="addJournalDialog = true"
                depressed
              >Journaleintrag erstellen</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <AddJournalEntryDialog
      v-model="addJournalDialog"
      :business="business"
    />
    <EditJournalEntryDialog
      v-model="editJournalDialog"
      :journalEntry="editJournalEntry"
    />
  </BaseLayout>
</template>

<script>
import Business from '@/models/business';
import Commission from '@/models/commission';
import JournalEntry from '@/models/journal-entry';
import File from '@/models/file';
import { confirmedDestroy } from '@/helpers/utils';
import cloneDeep from 'lodash.clonedeep';
import orderby from 'lodash.orderby';

export default {
  name: 'ShowBusiness',
  async asyncData({ id }) {
    await Promise.all([
      Business.findOrFetch(id),
      Business.fetchRelated('journal_entries', id),
      File.fetchAll(),
      Commission.fetchAll(),
    ]);
  },
  computed: {
    business() {
      if (this.businessCopy) {
        return this.businessCopy;
      }
      return Business.find(this.$route.params.id);
    },
    journalEntries() {
      return orderby(JournalEntry.query().where(
        'business_id',
        this.business.id,
      ).all(), j => j.relevance);
    },
    hasFiles() {
      return !!this.journalEntries.reduce((a, b) => a + b.files.length, 0);
    },
  },
  data() {
    return {
      businessCopy: null,
      addJournalDialog: false,
      editJournalDialog: false,
      editJournalEntry: new JournalEntry(),
      zipLoading: false,
    };
  },
  methods: {
    async downloadZip() {
      try {
        this.zipLoading = true;
        await this.business.downloadZip();
      } finally {
        this.zipLoading = false;
      }
    },
    confirmedDestroy,
    async destroy() {
      this.businessCopy = cloneDeep(this.business);
      if (await confirmedDestroy(this.business)) {
        this.$router.push({ name: 'businesses' });
      }
    },
    async editJournal(journalEntry) {
      this.editJournalEntry = cloneDeep(journalEntry);
      this.editJournalDialog = true;
    },
  },
};
</script>
